// POST /api/auth/signup/* (public; errors { error, code } → ApiError). Contract: packages/shared/src/signup.ts.

import type { PlanTier } from "@gf/shared";
import type { SignupCard, SignupDiscount, SignupState } from "@gf/shared/signup";
import { api } from "../../../lib/api";

const post = async <T,>(path: string, body: Record<string, unknown>) => {
  const result = await api<T & { metaEvents?: unknown[] }>(`/api/auth/signup/${path}`, { method: "POST", body, noAuthRedirect: true });
  // Events originate only from successful server transitions, never from a button click.
  if (result.metaEvents?.length) window.dispatchEvent(new CustomEvent('gramfather-meta-events', { detail: result.metaEvents }));
  return result as T;
};

export const signupApi = {
  start: (body: { plan: PlanTier; name: string; email: string; code?: string; website?: string }) => post<{ ok: boolean }>("start", body),
  /** Is this discount code usable? (400 promo_invalid) */
  checkCode: (code: string) => post<SignupDiscount>("check-code", { code }),
  /** Add, change or remove (null) the discount code before the trial starts. */
  promo: (session: string, code: string | null) => post<SignupState>("promo", { session, code }),
  recover: (email: string) => post<{ ok: boolean }>("recover", { email }),
  email: (token: string) => post<SignupState & { session: string }>("email", { token }),
  status: (session: string) => post<SignupState>("status", { session }),
  password: (session: string, password: string) => post<SignupState>("password", { session, password }),
  plan: (session: string, plan: PlanTier) => post<SignupState>("plan", { session, plan }),
  card: (session: string) => post<SignupCard>("card", { session }),
  activate: (session: string) => post<{ ok: boolean; url: string }>("activate", { session }),
};
